import { onBeforeUnmount, onMounted } from 'vue'

const ROGER_CARD_NUMBER_LENGTH = 10
const ROGER_CARD_READ_TIME_LIMIT_MS = 500
const ROGER_CARD_CHARACTER = /^[0-9A-Fa-f]$/
const EDITABLE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT']

function isEditableTarget(target: EventTarget | null): boolean {
    return target instanceof HTMLElement && (target.isContentEditable || EDITABLE_TAGS.includes(target.tagName))
}

export function useRogerCardReader(onRead: (cardNumber: string) => void): void {
    let cardNumber = ''
    let readStartedAt = 0

    function onKeydown(event: KeyboardEvent): void {
        if (event.key.length !== 1 || isEditableTarget(event.target) || event.metaKey || event.ctrlKey || event.altKey) {
            return
        }

        if (!ROGER_CARD_CHARACTER.test(event.key)) {
            cardNumber = ''
            return
        }

        const now = Date.now()

        if (!cardNumber || now - readStartedAt > ROGER_CARD_READ_TIME_LIMIT_MS) {
            cardNumber = ''
            readStartedAt = now
        }

        cardNumber += event.key

        if (cardNumber.length === ROGER_CARD_NUMBER_LENGTH) {
            const readCardNumber = cardNumber

            cardNumber = ''
            onRead(readCardNumber)
        }
    }

    onMounted(() => {
        window.addEventListener('keydown', onKeydown)
    })

    onBeforeUnmount(() => {
        window.removeEventListener('keydown', onKeydown)
    })
}
